import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: '/school-statis/list',
        data,
        method: 'post'
    })
};